// removed by extract-text-webpack-plugin
module.exports = {"container":"_2HemnM5GhkvrOYwfyQjrJp","icon":"dQmpOvMznpZw_v2j0waK9","title":"_2bjdD--NUqa0iKZagOEFs3","button":"_3DReM_rHlhfDk32BRHdJEb"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/UpdateFace/styles.css
// module id = 2904
// module chunks = 0